import { createSlice } from '@reduxjs/toolkit'
import type { PayloadAction } from '@reduxjs/toolkit'



const initialState = {
    isTabs: 'speech',
}

export const counterSlice = createSlice({
    name: 'type',
    initialState,
    reducers: {
        setIsTabs: (state, action: PayloadAction<any>) => {
            state.isTabs = action.payload
        },

    }
})

// Action creators are generated for each case reducer function
export const { setIsTabs, } = counterSlice.actions

export default counterSlice.reducer
